import { Component } from "@angular/core";

@Component({
	selector: "caass-schoolsetup",
	templateUrl: "./adminsetup.component.html",
})
export class AdminSetupComponent {}
